import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { KINDERGARTENS } from '../../common/constants/routes.constants';
import { useUserStore } from '../../store/useUserStore';
import { getUserAdministrationInfo } from '../../api/auth.api';
import BrandMark from '../../components/BrandMark';
import { useTranslation } from 'react-i18next';

const UnauthorizedPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setUserInfo } = useUserStore();

  const [checking, setChecking] = useState(true);

  // An admin can be deactivated and then reactivated on the api, so re-check
  // the account once on mount: that way a reload is enough to get back in,
  // instead of leaving the user stranded on this screen with a live session.
  useEffect(() => {
    checkAccess();
  }, []);

  const checkAccess = async () => {
    try {
      const res = await getUserAdministrationInfo();

      if (res?.isAdmin || res?.isKindergartenAdmin || res?.isSuperAdmin) {
        setUserInfo(res);
        navigate(KINDERGARTENS, { replace: true });
        return;
      }
    } catch (err) {
      console.error('Failed to re-check administration info', err);
    }

    setChecking(false);
  };

  if (checking) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <BrandMark width={42} height={50} style={{ marginBottom: 19 }} />
      <Typography variant="h1" color="error">
        {t('errors.noPermission')}
      </Typography>
    </Box>
  );
};

export default UnauthorizedPage;
